// actions.js
import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_DASHBOARD_DATA_REMOVE
} from '../types/index';
import { Dispatch } from 'redux';
import api from '../../api';
import { getPaymentGatewayDashboardSummaryData } from '../../api/apisUrl';

interface FetchDashboardDataRequestAction {
  type: typeof FETCH_DASHBOARD_DATA_REQUEST;
}

interface FetchDashboardDataSuccessAction {
  type: typeof FETCH_DASHBOARD_DATA_SUCCESS;
  payload: any;
}

interface FetchDashboardDataFailureAction {
  type: typeof FETCH_DASHBOARD_DATA_FAILURE;
  payload: string;
}
interface Dates {
  startDate: string
  , endDate: string
}

type DashboardDataAction =
  | FetchDashboardDataRequestAction
  | FetchDashboardDataSuccessAction
  | FetchDashboardDataFailureAction;

export const fetchDashboardData = (formattedDates: Dates, token: string, expressPayMerchantId?: any , role?:string) => {
  return (dispatch: Dispatch<DashboardDataAction>) => {
    dispatch({ type: FETCH_DASHBOARD_DATA_REQUEST });
    const params = () => {
      if (expressPayMerchantId&&role!='partner') {
        return {
          startDate: formattedDates?.startDate,
          endDate: formattedDates?.endDate,
          paymentStatus: "settled,decline,refund",
          userId: expressPayMerchantId
        }
      } else {
        return {
          startDate: formattedDates?.startDate,
          endDate: formattedDates?.endDate,
          paymentStatus: "settled,decline,refund",
        }
      }
    }

    api
      .get(
        getPaymentGatewayDashboardSummaryData(), {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: params()
      }
      )
      .then((response) => {
        dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: FETCH_DASHBOARD_DATA_FAILURE, payload: error.message });
      });
  };
};


export const removeFetchDashboardData = () => {
  return {
    type: FETCH_DASHBOARD_DATA_REMOVE
  }
}